export default "__VITE_ASSET__DwzwquSj__"